// 🎯 [lat, lng] تقريبية لعاصمة كل دولة - المفاتيح هنا لازم تطابق حرفيًا
// قيم دومين COUNTRY المزروعة في app/seed_data/baseline_reference_data.sql
// (نفس القايمة اللي UniversalLookup بيرجعها لما اليوزر يختار دولة في
// System Settings) عشان الإحداثيات الافتراضية تتحط أوتوماتيك من غير ما
// اليوزر يدخل Lat/Lng يدوي خالص
const COUNTRY_COORDINATES = {
  'AFGHANISTAN': [34.53, 69.17],
  'ALBANIA': [41.33, 19.82],
  'ALGERIA': [36.75, 3.06],
  'AMERICAN SAMOA': [-14.28, -170.70],
  'ANDORRA': [42.51, 1.52],
  'ANGOLA': [-8.84, 13.23],
  'ANGUILLA': [18.22, -63.06],
  'ANTARCTICA': [-75.25, 0.07],
  'ANTIGUA AND BARBUDA': [17.13, -61.85],
  'ARGENTINA': [-34.60, -58.38],
  'ARMENIA': [40.18, 44.51],
  'ARUBA': [12.52, -70.03],
  'AUSTRALIA': [-35.28, 149.13],
  'AUSTRIA': [48.21, 16.37],
  'AZERBAIJAN': [40.41, 49.87],
  'BAHAMAS (THE)': [25.06, -77.35],
  'BAHRAIN': [26.23, 50.59],
  'BANGLADESH': [23.81, 90.41],
  'BARBADOS': [13.10, -59.62],
  'BELARUS': [53.90, 27.57],
  'BELGIUM': [50.85, 4.35],
  'BELIZE': [17.25, -88.77],
  'BENIN': [6.50, 2.60],
  'BERMUDA': [32.29, -64.78],
  'BHUTAN': [27.47, 89.64],
  'BOLIVIA (PLURINATIONAL STATE OF)': [-16.50, -68.15],
  'BONAIRE, SINT EUSTATIUS AND SABA': [12.15, -68.28],
  'BOSNIA AND HERZEGOVINA': [43.86, 18.41],
  'BOTSWANA': [-24.63, 25.90],
  'BOUVET ISLAND': [-54.43, 3.38],
  'BRAZIL': [-15.79, -47.88],
  'BRITISH INDIAN OCEAN TERRITORY (THE)': [-7.32, 72.42],
  'BRUNEI DARUSSALAM': [4.94, 114.94],
  'BULGARIA': [42.70, 23.32],
  'BURKINA FASO': [12.37, -1.52],
  'BURUNDI': [-3.43, 29.93],
  'CABO VERDE': [14.93, -23.51],
  'CAMBODIA': [11.56, 104.92],
  'CAMEROON': [3.87, 11.52],
  'CANADA': [45.42, -75.70],
  'CAYMAN ISLANDS (THE)': [19.29, -81.38],
  'CENTRAL AFRICAN REPUBLIC (THE)': [4.39, 18.56],
  'CHAD': [12.13, 15.06],
  'CHILE': [-33.45, -70.67],
  'CHINA': [39.90, 116.41],
  'CHRISTMAS ISLAND': [-10.42, 105.68],
  'COCOS (KEELING) ISLANDS (THE)': [-12.19, 96.87],
  'COLOMBIA': [4.71, -74.07],
  'COMOROS (THE)': [-11.70, 43.26],
  'CONGO (THE DEMOCRATIC REPUBLIC OF THE)': [-4.44, 15.27],
  'CONGO (THE)': [-4.26, 15.28],
  'COOK ISLANDS (THE)': [-21.21, -159.78],
  'COSTA RICA': [9.93, -84.08],
  'CROATIA': [45.82, 15.98],
  'CUBA': [23.13, -82.38],
  'CURAÇAO': [12.11, -68.93],
  'CYPRUS': [35.19, 33.38],
  'CZECHIA': [50.09, 14.42],
  "CÔTE D'IVOIRE": [6.83, -5.29],
  'DENMARK': [55.68, 12.57],
  'DJIBOUTI': [11.59, 43.15],
  'DOMINICA': [15.30, -61.39],
  'DOMINICAN REPUBLIC (THE)': [18.49, -69.94],
  'ECUADOR': [-0.23, -78.51],
  'EGYPT': [30.04, 31.24],
  'EL SALVADOR': [13.69, -89.22],
  'EQUATORIAL GUINEA': [3.75, 8.78],
  'ERITREA': [15.32, 38.93],
  'ESTONIA': [59.44, 24.75],
  'ESWATINI': [-26.32, 31.13],
  'ETHIOPIA': [9.03, 38.74],
  'FALKLAND ISLANDS (THE) [MALVINAS]': [-51.70, -57.85],
  'FAROE ISLANDS (THE)': [62.01, -6.77],
  'FIJI': [-18.14, 178.44],
  'FINLAND': [60.17, 24.94],
  'FRANCE': [48.86, 2.35],
  'FRENCH GUIANA': [4.94, -52.33],
  'FRENCH POLYNESIA': [-17.53, -149.57],
  'FRENCH SOUTHERN TERRITORIES (THE)': [-49.35, 70.22],
  'GABON': [0.42, 9.45],
  'GAMBIA (THE)': [13.45, -16.58],
  'GEORGIA': [41.72, 44.79],
  'GERMANY': [52.52, 13.40],
  'GHANA': [5.60, -0.19],
  'GIBRALTAR': [36.14, -5.35],
  'GREECE': [37.98, 23.73],
  'GREENLAND': [64.18, -51.69],
  'GRENADA': [12.06, -61.75],
  'GUADELOUPE': [16.00, -61.73],
  'GUAM': [13.48, 144.75],
  'GUATEMALA': [14.63, -90.53],
  'GUERNSEY': [49.46, -2.54],
  'GUINEA': [9.64, -13.58],
  'GUINEA-BISSAU': [11.86, -15.60],
  'GUYANA': [6.80, -58.16],
  'HAITI': [18.59, -72.31],
  'HEARD ISLAND AND MCDONALD ISLANDS': [-53.08, 73.50],
  'HOLY SEE (THE)': [41.90, 12.45],
  'HONDURAS': [14.07, -87.19],
  'HONG KONG': [22.32, 114.17],
  'HUNGARY': [47.50, 19.04],
  'ICELAND': [64.15, -21.94],
  'INDIA': [28.61, 77.21],
  'INDONESIA': [-6.21, 106.85],
  'IRAN (ISLAMIC REPUBLIC OF)': [35.69, 51.39],
  'IRAQ': [33.31, 44.36],
  'IRELAND': [53.35, -6.26],
  'ISLE OF MAN': [54.15, -4.48],
  'ITALY': [41.90, 12.50],
  'JAMAICA': [17.97, -76.79],
  'JAPAN': [35.68, 139.65],
  'JERSEY': [49.19, -2.11],
  'JORDAN': [31.95, 35.93],
  'KAZAKHSTAN': [51.17, 71.43],
  'KENYA': [-1.29, 36.82],
  'KIRIBATI': [1.45, 173.02],
  "KOREA (THE DEMOCRATIC PEOPLE'S REPUBLIC OF)": [39.02, 125.75],
  'KOREA (THE REPUBLIC OF)': [37.57, 126.98],
  'KUWAIT': [29.38, 47.99],
  'KYRGYZSTAN': [42.87, 74.59],
  "LAO PEOPLE'S DEMOCRATIC REPUBLIC (THE)": [17.97, 102.60],
  'LATVIA': [56.95, 24.11],
  'LEBANON': [33.89, 35.50],
  'LESOTHO': [-29.32, 27.48],
  'LIBERIA': [6.30, -10.80],
  'LIBYA': [32.89, 13.19],
  'LIECHTENSTEIN': [47.14, 9.52],
  'LITHUANIA': [54.69, 25.28],
  'LUXEMBOURG': [49.61, 6.13],
  'MACAO': [22.20, 113.54],
  'MADAGASCAR': [-18.88, 47.51],
  'MALAWI': [-13.96, 33.77],
  'MALAYSIA': [3.14, 101.69],
  'MALDIVES': [4.18, 73.51],
  'MALI': [12.65, -8.00],
  'MALTA': [35.90, 14.51],
  'MARSHALL ISLANDS (THE)': [7.12, 171.18],
  'MARTINIQUE': [14.60, -61.07],
  'MAURITANIA': [18.08, -15.98],
  'MAURITIUS': [-20.16, 57.50],
  'MAYOTTE': [-12.78, 45.23],
  'MEXICO': [19.43, -99.13],
  'MICRONESIA (FEDERATED STATES OF)': [6.92, 158.16],
  'MOLDOVA (THE REPUBLIC OF)': [47.01, 28.86],
  'MONACO': [43.74, 7.42],
  'MONGOLIA': [47.89, 106.91],
  'MONTENEGRO': [42.44, 19.26],
  'MONTSERRAT': [16.79, -62.20],
  'MOROCCO': [34.02, -6.83],
  'MOZAMBIQUE': [-25.97, 32.57],
  'MYANMAR': [19.76, 96.08],
  'NAMIBIA': [-22.56, 17.08],
  'NAURU': [-0.55, 166.92],
  'NEPAL': [27.72, 85.32],
  'NETHERLANDS (THE)': [52.37, 4.90],
  'NEW CALEDONIA': [-22.28, 166.46],
  'NEW ZEALAND': [-41.29, 174.78],
  'NICARAGUA': [12.11, -86.24],
  'NIGER (THE)': [13.51, 2.11],
  'NIGERIA': [9.08, 7.40],
  'NIUE': [-19.06, -169.92],
  'NORFOLK ISLAND': [-29.06, 167.96],
  'NORTHERN MARIANA ISLANDS (THE)': [15.19, 145.75],
  'NORWAY': [59.91, 10.75],
  'OMAN': [23.59, 58.38],
  'PAKISTAN': [33.68, 73.05],
  'PALAU': [7.50, 134.62],
  'PALESTINE, STATE OF': [31.90, 35.20],
  'PANAMA': [8.98, -79.52],
  'PAPUA NEW GUINEA': [-9.44, 147.18],
  'PARAGUAY': [-25.28, -57.63],
  'PERU': [-12.05, -77.04],
  'PHILIPPINES (THE)': [14.60, 120.98],
  'PITCAIRN': [-25.07, -130.10],
  'POLAND': [52.23, 21.01],
  'PORTUGAL': [38.72, -9.14],
  'PUERTO RICO': [18.47, -66.11],
  'QATAR': [25.29, 51.53],
  'REPUBLIC OF NORTH MACEDONIA': [42.00, 21.43],
  'ROMANIA': [44.43, 26.11],
  'RUSSIAN FEDERATION (THE)': [55.76, 37.62],
  'RWANDA': [-1.94, 30.06],
  'RÉUNION': [-20.88, 55.45],
  'SAINT BARTHÉLEMY': [17.90, -62.85],
  'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA': [-15.93, -5.72],
  'SAINT KITTS AND NEVIS': [17.30, -62.72],
  'SAINT LUCIA': [14.01, -60.99],
  'SAINT MARTIN (FRENCH PART)': [18.07, -63.08],
  'SAINT PIERRE AND MIQUELON': [46.78, -56.18],
  'SAINT VINCENT AND THE GRENADINES': [13.16, -61.22],
  'SAMOA': [-13.83, -171.76],
  'SAN MARINO': [43.94, 12.46],
  'SAO TOME AND PRINCIPE': [0.34, 6.73],
  'SAUDI ARABIA': [24.71, 46.68],
  'SENEGAL': [14.72, -17.47],
  'SERBIA': [44.79, 20.45],
  'SEYCHELLES': [-4.62, 55.45],
  'SIERRA LEONE': [8.48, -13.23],
  'SINGAPORE': [1.35, 103.82],
  'SINT MAARTEN (DUTCH PART)': [18.03, -63.05],
  'SLOVAKIA': [48.15, 17.11],
  'SLOVENIA': [46.06, 14.51],
  'SOLOMON ISLANDS': [-9.43, 159.95],
  'SOMALIA': [2.05, 45.32],
  'SOUTH AFRICA': [-25.75, 28.19],
  'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS': [-54.28, -36.50],
  'SOUTH SUDAN': [4.85, 31.58],
  'SPAIN': [40.42, -3.70],
  'SRI LANKA': [6.90, 79.90],
  'SUDAN (THE)': [15.50, 32.56],
  'SURINAME': [5.87, -55.17],
  'SVALBARD AND JAN MAYEN': [78.22, 15.63],
  'SWEDEN': [59.33, 18.07],
  'SWITZERLAND': [46.95, 7.45],
  'SYRIAN ARAB REPUBLIC': [33.51, 36.28],
  'TAIWAN (PROVINCE OF CHINA)': [25.03, 121.57],
  'TAJIKISTAN': [38.56, 68.77],
  'TANZANIA, UNITED REPUBLIC OF': [-6.16, 35.75],
  'THAILAND': [13.76, 100.50],
  'TIMOR-LESTE': [-8.56, 125.57],
  'TOGO': [6.13, 1.22],
  'TOKELAU': [-9.38, -171.22],
  'TONGA': [-21.14, -175.20],
  'TRINIDAD AND TOBAGO': [10.65, -61.52],
  'TUNISIA': [36.81, 10.18],
  'TURKEY': [39.93, 32.86],
  'TURKMENISTAN': [37.95, 58.38],
  'TURKS AND CAICOS ISLANDS (THE)': [21.46, -71.14],
  'TUVALU': [-8.52, 179.20],
  'UGANDA': [0.35, 32.58],
  'UKRAINE': [50.45, 30.52],
  'UNITED ARAB EMIRATES (THE)': [24.45, 54.38],
  'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND (THE)': [51.51, -0.13],
  'UNITED STATES MINOR OUTLYING ISLANDS (THE)': [19.29, 166.63],
  'UNITED STATES OF AMERICA (THE)': [38.91, -77.04],
  'URUGUAY': [-34.90, -56.16],
  'UZBEKISTAN': [41.30, 69.24],
  'VANUATU': [-17.73, 168.32],
  'VENEZUELA (BOLIVARIAN REPUBLIC OF)': [10.49, -66.88],
  'VIET NAM': [21.03, 105.85],
  'VIRGIN ISLANDS (BRITISH)': [18.43, -64.62],
  'VIRGIN ISLANDS (U.S.)': [18.34, -64.93],
  'WALLIS AND FUTUNA': [-13.28, -176.17],
  'WESTERN SAHARA': [27.15, -13.20],
  'YEMEN': [15.37, 44.19],
  'ZAMBIA': [-15.39, 28.32],
  'ZIMBABWE': [-17.83, 31.05],
  'ÅLAND ISLANDS': [60.10, 19.94],
};

export default COUNTRY_COORDINATES;
